module.exports = __webpack_public_path__ + "img/TE_Estate_sjkfhkjhrj_3.a5260d40.jpeg";